import React, { Component } from 'react'
import { StoreContext } from './context/store.context'
import { GroupsContext } from './context/groups.context'
import { CategoriesContext } from './context/categories.context'
import { defaultState, reducer } from './store/reducer'
import PropTypes from 'prop-types'

class GroupsSelectionProvider extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ...defaultState,
      selectedGroups: props.selected ? props.selected : {},
      dispatch: action => this.setState(state => reducer(state, action))
    }
  }
  render() {
    const { groups, categories, children } = this.props
    return (
      <StoreContext.Provider value={this.state}>
        <GroupsContext.Provider value={groups}>
          <CategoriesContext.Provider value={categories}>
            {children(this.state)}
          </CategoriesContext.Provider>
        </GroupsContext.Provider>
      </StoreContext.Provider>
    )
  }
}

GroupsSelectionProvider.propTypes = {
  /** Array of groups structured as in pobble-api-v3 */
  groups: PropTypes.array,
  /** Array of group categories structured as in pobble-api-v3 */
  categories: PropTypes.array,
  /** Render props pattern children (function that receives store as a prop) */
  children: PropTypes.func.isRequired,
  /** Map of selected groups structured as object, e.q. {1: true, 3: true} */
  selected: PropTypes.object
}

export default GroupsSelectionProvider
